import { externalRoutes, routes } from '~constants/routes';
import { useTranslations } from '~i18n/hooks';

import CharacterIcon from '../../../public/assets/icons/navigation/character.svg';
import ChatsIcon from '../../../public/assets/icons/navigation/chats.svg';
import CreateIcon from '../../../public/assets/icons/navigation/create.svg';
import ExploreIcon from '../../../public/assets/icons/navigation/explore.svg';
import ImagesIcon from '../../../public/assets/icons/navigation/images.svg';
import VideosIcon from '../../../public/assets/icons/navigation/videos.svg';
import type { NavigationElement, NavigationPathWithoutText } from './types';

const explore: NavigationPathWithoutText = {
	path: routes.explore.models,
	icon: <ExploreIcon />,
	isDemo: true,
	isSafe: false,
	mobileOrder: 0,
	'data-name': 'explore-menu-item',
};

const chat: NavigationPathWithoutText = {
	path: routes.chats.home,
	icon: <ChatsIcon />,
	isDemo: true,
	isSafe: true,
	mobileOrder: 2,
	withMessageCounter: true,
	'data-name': 'chat-menu-item',
};

const gallery: NavigationPathWithoutText = {
	// TODO: Change when page will be ready
	// path: routes.gallery.home,
	path: routes.generate.images,
	isDemo: true,
	isSafe: true,
	'data-name': 'gallery-menu-item',
};

const createCharacter: NavigationPathWithoutText = {
	path: routes.generate.character,
	icon: <CharacterIcon />,
	isDemo: true,
	isSafe: false,
	'data-name': 'create-character-menu-item',
};

const generateImages: NavigationPathWithoutText = {
	path: routes.generate.images,
	icon: <ImagesIcon />,
	withoutQuery: { video: 'true' },
	isDemo: true,
	isSafe: false,
	'data-name': 'generate-images-menu-item',
};

const generateVideos: NavigationPathWithoutText = {
	path: routes.generate.videos,
	icon: <VideosIcon />,
	isDemo: false,
	isSafe: false,
	new: true,
	'data-name': 'generate-videos-menu-item',
};

// const academyUrl = getSubdomainUrlStr('academy');

const becomeAffiliate: NavigationPathWithoutText = {
	path: externalRoutes.becomeAffiliate,
	isDemo: true,
	isSafe: true,
	'data-name': 'become-affiliate-menu-item',
};
const creatorPartnership: NavigationPathWithoutText = {
	path: externalRoutes.creatorUrl,
	isDemo: true,
	isSafe: true,
	'data-name': 'create-partnership-menu-item',
};

const aboutUs: NavigationPathWithoutText = {
	path: routes.company.about,
	targetBlank: true,
	isDemo: true,
	isSafe: true,
	'data-name': 'about-us-menu-item',
};

export function useNavigationPaths(): NavigationElement[] {
	const t = useTranslations('Header');

	return [
		{
			...explore,
			text: t('exploreMenuTitle'),
		},
		{
			...chat,
			text: t('chatsMenuTitle'),
		},
		{
			icon: <CreateIcon />,
			text: t('createMenuTitle'),
			mobileOrder: 1,
			children: [
				{
					...createCharacter,
					text: t('createCharacterSubmenuTitle'),
				},
				{
					...generateImages,
					text: t('generateImagesSubmenuTitle'),
				},
				{
					...generateVideos,
					text: t('generateVideosSubmenuTitle'),
				},
			],
			'data-name': 'create-menu-item',
		},
	];
}

export function useNavigationPathsSideMenu(): NavigationElement[] {
	const t = useTranslations('SideMenu');

	return [
		{
			text: '',
			children: [
				{
					...explore,
					text: t('exploreMenuTitle'),
				},
				{
					...gallery,
					text: t('galleryMenuTitle'),
				},
				{
					...chat,
					text: t('chatsMenuTitle'),
				},
			],
			'data-name': 'main-section',
		},
		{
			text: t('aiToolsMenuSectionTitle'),
			children: [
				{
					...createCharacter,
					text: t('createCharacterMenuTitle'),
				},
				{
					...generateImages,
					text: t('generateImagesMenuTitle'),
				},
				{
					...generateVideos,
					text: t('generateVideosMenuTitle'),
				},
			],
			'data-name': 'ai-tools-section',
		},
		{
			text: t('earnMenuSectionTitle'),
			children: [
				{ ...becomeAffiliate, text: t('affiliateMenuTitle') },
				{
					...creatorPartnership,
					text: t('partnershipMenuTitle'),
				},
			],
			'data-name': 'earn-section',
		},
		{
			text: '',
			children: [{ ...aboutUs, text: t('aboutUsMenuTitle') }],
			'data-name': 'about-section',
		},
	];
}
